
import { Component, Vue } from "vue-property-decorator";
import SpecialListTep from "@/template/special/SpecialList.vue";
@Component
export default class SpecialList extends SpecialListTep {}
